// AdapterCard.jsx — Grid card for an adapter. Click → opens AdapterSheet.

import clsx from 'clsx';
import AdapterLogo from './AdapterLogo.jsx';

export default function AdapterCard({ adapter, onClick }) {
  const isLocal = adapter.badge === 'LOCAL';
  const isBeta = adapter.badge === 'BETA';
  const isAsync = adapter.badge === 'ASYNC';
  const isCustom = !adapter.is_builtin;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Configurar ${adapter.display_name}`}
      className={clsx(
        'flex flex-col items-start gap-1 rounded-lg border border-apolo-borderSubtle bg-apolo-surface2 p-3 text-left transition',
        'hover:border-apolo-accent hover:bg-apolo-surface3 focus:outline-none focus:ring-2 focus:ring-apolo-accent/50',
      )}
    >
      <div className="flex w-full items-center gap-2">
        <AdapterLogo adapter={adapter} size={20} />
        <span className="flex-1 truncate text-sm font-medium">{adapter.display_name}</span>
        {adapter.has_api_key && (
          <span
            title="API key configurada"
            className="h-2 w-2 rounded-full bg-emerald-400"
            aria-label="API key configurada"
          />
        )}
      </div>
      <p className="line-clamp-2 text-xs text-apolo-textSecondary">{adapter.description}</p>
      <div className="mt-1 flex flex-wrap gap-1">
        {isLocal && <Badge tone="green">LOCAL</Badge>}
        {isBeta && <Badge tone="amber">BETA</Badge>}
        {isAsync && <Badge tone="blue">ASYNC</Badge>}
        {isCustom && <Badge tone="violet">CUSTOM</Badge>}
        {!adapter.is_active && <Badge tone="gray">OFF</Badge>}
      </div>
    </button>
  );
}

function Badge({ tone, children }) {
  const cls = {
    green: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
    amber: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
    blue: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
    violet: 'bg-violet-500/15 text-violet-300 border-violet-500/30',
    gray: 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30',
  }[tone];
  return (
    <span className={`inline-flex items-center rounded border px-1.5 text-[10px] font-medium leading-4 ${cls}`}>
      {children}
    </span>
  );
}
